function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11.948 12.2v.8a4 4 0 01-4 4H5a4 4 0 01-4-4V5a4 4 0 014-4h2.948a4 4 0 014 4v.8M14.474 11.402l1.763-1.675a1 1 0 000-1.45l-1.763-1.675M16.158 9H6.053",
  stroke: "#B0B8CE",
  strokeWidth: 1.5,
  strokeLinecap: "round"
});

function SvgLogout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 18 18",
    fill: "none"
  }, props), _ref);
}

export default SvgLogout;


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/Logout.svg
// module id = 1318
// module chunks = 10